export enum WAREHOUSE_NOTIFICATION {
  INQUIRY_REQUEST_ARRIVES = 'INQUIRY_REQUEST_ARRIVES',
  APPROVE_INQUIRY = 'APPROVE_INQUIRY',
  REJECT_INQUIRY = 'REJECT_INQUIRY',
  IMPORT_REQUESTED = 'IMPORT_REQUESTED',
  DELIVERY_REQUESTED = 'DELIVERY_REQUESTED',
  RETURN_IMPORT_REQUESTED = 'RETURN_IMPORT_REQUESTED',
  RETURN_STOCK_REQUESTED = 'RETURN_STOCK_REQUESTED',
  EXCHANGE_REQUESTED = 'EXCHANGE_REQUESTED',
  DISPOSAL_IMPORT_REQUESTED = 'DISPOSAL_IMPORT_REQUESTED',
  DISPOSAL_STOCK_REQUESTED = 'DISPOSAL_STOCK_REQUESTED',
  SETTLEMENT_APPROVED = 'SETTLEMENT_APPROVED',
  BUSK_SETTLEMENT_REQUESTED = 'BUSK_SETTLEMENT_REQUESTED',
  //
  MODIFY_INQUIRY = 'MODIFY_INQUIRY',
  MODIFY_INBOUND = 'MODIFY_INBOUND',
  MODIFY_DELIVERY = 'MODIFY_DELIVERY',
  MODIFY_RETURN_IMPORT = 'MODIFY_RETURN_IMPORT',
  MODIFY_DISPOSAL_IMPORT = 'MODIFY_DISPOSAL_IMPORT',
  DELETE_DELIVERY = 'DELETE_DELIVERY',
  DELETE_INBOUND = 'DELETE_INBOUND',
  DELETE_RETURN_IMPORT = 'DELETE_RETURN_IMPORT',
  DELETE_DISPOSAL_IMPORT = 'DELETE_DISPOSAL_IMPORT',
  APPROVE_MODIFY_INBOUND = 'APPROVE_MODIFY_INBOUND',
  APPROVE_MODIFY_DELIVERY = 'APPROVE_MODIFY_DELIVERY',
  APPROVE_MODIFY_RETURN_IMPORT = 'APPROVE_MODIFY_RETURN_IMPORT',
  APPROVE_MODIFY_DISPOSAL_IMPORT = 'APPROVE_MODIFY_DISPOSAL_IMPORT',
  APPROVE_MODIFY_RETURN_STOCK = 'APPROVE_MODIFY_RETURN_STOCK',
  APPROVE_MODIFY_RETURN_ORDER = 'APPROVE_MODIFY_RETURN_ORDER',
  APPROVE_MODIFY_DISPOSAL_STOCK = 'APPROVE_MODIFY_DISPOSAL_STOCK',
  APPROVE_MODIFY_DISPOSAL_ORDER = 'APPROVE_MODIFY_DISPOSAL_ORDER',
  APPROVE_DELETE_INBOUND = 'APPROVE_DELETE_INBOUND',
  APPROVE_DELETE_DELIVERY = 'APPROVE_DELETE_DELIVERY',
  APPROVE_DELETE_RETURN_IMPORT = 'APPROVE_DELETE_RETURN_IMPORT',
  APPROVE_DELETE_DISPOSAL_IMPORT = 'APPROVE_DELETE_DISPOSAL_IMPORT',
  APPROVE_DELETE_RETURN_STOCK = 'APPROVE_DELETE_RETURN_STOCK',
  APPROVE_DELETE_RETURN_ORDER = 'APPROVE_DELETE_RETURN_ORDER',
  APPROVE_DELETE_DISPOSAL_STOCK = 'APPROVE_DELETE_DISPOSAL_STOCK',
  APPROVE_DELETE_DISPOSAL_ORDER = 'APPROVE_DELETE_DISPOSAL_ORDER',
  REJECT_MODIFY_INBOUND = 'REJECT_MODIFY_INBOUND',
  REJECT_MODIFY_DELIVERY = 'REJECT_MODIFY_DELIVERY',
  REJECT_DELETE_INBOUND = 'REJECT_DELETE_INBOUND',
  REJECT_DELETE_DELIVERY = 'REJECT_DELETE_DELIVERY',
  REJECT_MODIFY_RETURN_IMPORT = 'REJECT_MODIFY_RETURN_IMPORT',
  REJECT_MODIFY_RETURN_STOCK = 'REJECT_MODIFY_RETURN_STOCK',
  REJECT_MODIFY_RETURN_ORDER = 'REJECT_MODIFY_RETURN_ORDER',
  REJECT_MODIFY_DISPOSAL_IMPORT = 'REJECT_MODIFY_DISPOSAL_IMPORT',
  REJECT_MODIFY_DISPOSAL_STOCK = 'REJECT_MODIFY_DISPOSAL_STOCK',
  REJECT_MODIFY_DISPOSAL_ORDER = 'REJECT_MODIFY_DISPOSAL_ORDER',
  REJECT_DELETE_RETURN_IMPORT = 'REJECT_DELETE_RETURN_IMPORT',
  REJECT_DELETE_RETURN_STOCK = 'REJECT_DELETE_RETURN_STOCK',
  REJECT_DELETE_RETURN_ORDER = 'REJECT_DELETE_RETURN_ORDER',
  REJECT_DELETE_DISPOSAL_IMPORT = 'REJECT_DELETE_DISPOSAL_IMPORT',
  REJECT_DELETE_DISPOSAL_STOCK = 'REJECT_DELETE_DISPOSAL_STOCK',
  REJECT_DELETE_DISPOSAL_ORDER = 'REJECT_DELETE_DISPOSAL_ORDER',
  DELETE_RETURN_STOCK = 'DELETE_RETURN_STOCK',
  DELETE_DISPOSAL_STOCK = 'DELETE_DISPOSAL_STOCK',
  DELETE_RETURN_ORDER = 'DELETE_RETURN_ORDER',
  DELETE_DISPOSAL_ORDER = 'DELETE_DISPOSAL_ORDER',
  MODIFY_RETURN_STOCK = 'MODIFY_RETURN_STOCK',
  MODIFY_DISPOSAL_STOCK = 'MODIFY_DISPOSAL_STOCK',
  MODIFY_RETURN_ORDER = 'MODIFY_RETURN_ORDER',
  MODIFY_DISPOSAL_ORDER = 'MODIFY_DISPOSAL_ORDER',
  APPROVE_MODIFY_INQUIRY = 'APPROVE_MODIFY_INQUIRY',
  APPROVE_DELETE_INQUIRY = 'APPROVE_DELETE_INQUIRY',
  REJECT_MODIFY_INQUIRY = 'REJECT_MODIFY_INQUIRY',
  REJECT_DELETE_INQUIRY = 'REJECT_DELETE_INQUIRY',
}

export enum SELLER_NOTIFICATION {
  APPROVE_INQUIRY = 'APPROVE_INQUIRY',
  REJECT_INQUIRY = 'REJECT_INQUIRY',
  APPROVE_IMPORT_REQUEST = 'APPROVE_IMPORT_REQUEST',
  IMPORT_CONFIRMED = 'IMPORT_CONFIRMED',
  REGISTER_DELIVERY_INFO = 'REGISTER_DELIVERY_INFO',
  REQUEST_RETURN = 'REQUEST_RETURN',
  REQUEST_EXCHANGE = 'REQUEST_EXCHANGE',
  REQUEST_DISPOSAL = 'REQUEST_DISPOSAL',
  REQUEST_SETTLEMENT = 'REQUEST_SETTLEMENT',
  //
  MODIFY_INQUIRY = 'MODIFY_INQUIRY',
  MODIFY_DELIVERY = 'MODIFY_DELIVERY',
  MODIFY_INBOUND = 'MODIFY_INBOUND',
  MODIFY_RETURN_IMPORT = 'MODIFY_RETURN_IMPORT',
  MODIFY_RETURN_ORDER = 'MODIFY_RETURN_ORDER',
  MODIFY_RETURN_STOCK = 'MODIFY_RETURN_STOCK',
  MODIFY_DISPOSAL_IMPORT = 'MODIFY_DISPOSAL_IMPORT',
  MODIFY_DISPOSAL_STOCK = 'MODIFY_DISPOSAL_STOCK',
  MODIFY_DISPOSAL_ORDER = 'MODIFY_DISPOSAL_ORDER',
  DELETE_RETURN_ORDER = 'DELETE_RETURN_ORDER',
  DELETE_DISPOSAL_ORDER = 'DELETE_DISPOSAL_ORDER',
  APPROVE_MODIFY_INQUIRY = 'APPROVE_MODIFY_INQUIRY',
  APPROVE_MODIFY_DELIVERY = 'APPROVE_MODIFY_DELIVERY',
  APPROVE_MODIFY_RETURN_ORDER = 'APPROVE_MODIFY_RETURN_ORDER',
  APPROVE_MODIFY_RETURN_IMPORT = 'APPROVE_MODIFY_RETURN_IMPORT',
  APPROVE_DELETE_INQUIRY = 'APPROVE_DELETE_INQUIRY',
  APPROVE_DELETE_RETURN_ORDER = 'APPROVE_DELETE_RETURN_ORDER',
  REJECT_DELETE_INQUIRY = 'REJECT_DELETE_INQUIRY',
  REJECT_DELETE_DELIVERY = 'REJECT_DELETE_DELIVERY',
  REJECT_MODIFY_RETURN_ORDER = 'REJECT_MODIFY_RETURN_ORDER',
  REJECT_MODIFY_RETURN_IMPORT = 'REJECT_MODIFY_RETURN_IMPORT',
  REJECT_DELETE_RETURN_ORDER = 'REJECT_DELETE_RETURN_ORDER',
  APPROVE_MODIFY_INBOUND = 'APPROVE_MODIFY_INBOUND',
  APPROVE_DELETE_INBOUND = 'APPROVE_DELETE_INBOUND',
  REJECT_MODIFY_INBOUND = 'REJECT_MODIFY_INBOUND',
  REJECT_DELETE_INBOUND = 'REJECT_DELETE_INBOUND',
  APPROVE_DELETE_DELIVERY = 'APPROVE_DELETE_DELIVERY',
  REJECT_MODIFY_INQUIRY = 'REJECT_MODIFY_INQUIRY',
  REJECT_MODIFY_DELIVERY = 'REJECT_MODIFY_DELIVERY',
  DELETE_RETURN_IMPORT = 'DELETE_RETURN_IMPORT',
  DELETE_DISPOSAL_IMPORT = 'DELETE_DISPOSAL_IMPORT',
  DELETE_RETURN_STOCK = 'DELETE_RETURN_STOCK',
  DELETE_DISPOSAL_STOCK = 'DELETE_DISPOSAL_STOCK',
  APPROVE_MODIFY_RETURN_STOCK = 'APPROVE_MODIFY_RETURN_STOCK',
  APPROVE_MODIFY_DISPOSAL_ORDER = 'APPROVE_MODIFY_DISPOSAL_ORDER',
  APPROVE_MODIFY_DISPOSAL_IMPORT = 'APPROVE_MODIFY_DISPOSAL_IMPORT',
  APPROVE_MODIFY_DISPOSAL_STOCK = 'APPROVE_MODIFY_DISPOSAL_STOCK',
  APPROVE_DELETE_RETURN_IMPORT = 'APPROVE_DELETE_RETURN_IMPORT',
  APPROVE_DELETE_RETURN_STOCK = 'APPROVE_DELETE_RETURN_STOCK',
  APPROVE_DELETE_DISPOSAL_ORDER = 'APPROVE_DELETE_DISPOSAL_ORDER',
  APPROVE_DELETE_DISPOSAL_IMPORT = 'APPROVE_DELETE_DISPOSAL_IMPORT',
  APPROVE_DELETE_DISPOSAL_STOCK = 'APPROVE_DELETE_DISPOSAL_STOCK',
  REJECT_MODIFY_RETURN_STOCK = 'REJECT_MODIFY_RETURN_STOCK',
  REJECT_MODIFY_DISPOSAL_ORDER = 'REJECT_MODIFY_DISPOSAL_ORDER',
  REJECT_MODIFY_DISPOSAL_IMPORT = 'REJECT_MODIFY_DISPOSAL_IMPORT',
  REJECT_MODIFY_DISPOSAL_STOCK = 'REJECT_MODIFY_DISPOSAL_STOCK',
  REJECT_DELETE_RETURN_IMPORT = 'REJECT_DELETE_RETURN_IMPORT',
  REJECT_DELETE_RETURN_STOCK = 'REJECT_DELETE_RETURN_STOCK',
  REJECT_DELETE_DISPOSAL_ORDER = 'REJECT_DELETE_DISPOSAL_ORDER',
  REJECT_DELETE_DISPOSAL_IMPORT = 'REJECT_DELETE_DISPOSAL_IMPORT',
  REJECT_DELETE_DISPOSAL_STOCK = 'REJECT_DELETE_DISPOSAL_STOCK',
  INVENTORY_CONVERSION_APPROVE = 'INVENTORY_CONVERSION_APPROVE',
}

export interface Notification {
  id: number;
  title: string;
  isRead: boolean;
  group: string;
  type: WAREHOUSE_NOTIFICATION | SELLER_NOTIFICATION;
  userId: number;
  itemId: number;
  createdAt: Date;
}

export interface NotificationListResponse {
  total: number;
  list: Array<Notification>;
}

export const NotificationLink = {
  seller: {
    [SELLER_NOTIFICATION.APPROVE_INQUIRY]: (id: number) => `/admin/seller/quote/${id}`, // Approve Inquiry
    [SELLER_NOTIFICATION.REJECT_INQUIRY]: (id: number) => `/admin/seller/quote/${id}`, // Reject Inquiry
    [SELLER_NOTIFICATION.APPROVE_IMPORT_REQUEST]: (id: number) => `/admin/seller/import/${id}`, // Approve import request
    [SELLER_NOTIFICATION.IMPORT_CONFIRMED]: (id: number) => `/admin/seller/import/${id}`, // Import confirmed
    [SELLER_NOTIFICATION.REGISTER_DELIVERY_INFO]: (id: number) => `/admin/seller/shipping/${id}`, // Register delivery info
    [SELLER_NOTIFICATION.REQUEST_RETURN]: (id: number) => `/admin/seller/shipping/return-request/${id}`, // Request return
    [SELLER_NOTIFICATION.REQUEST_EXCHANGE]: (id: number) => `/admin/seller/shipping/return-request/${id}`, // Request exchange
    [SELLER_NOTIFICATION.REQUEST_DISPOSAL]: (id: number) => `/admin/seller/shipping/return-request/${id}`, // Request disposal
    [SELLER_NOTIFICATION.REQUEST_SETTLEMENT]: (id: number) => `/admin/seller/settlement/${id}`, // Request settlement
    //for comment
    [SELLER_NOTIFICATION.MODIFY_INQUIRY]: (id: number) => `/admin/seller/quote/${id}`,
    [SELLER_NOTIFICATION.MODIFY_INBOUND]: (id: number) => `/admin/seller/import/${id}`,
    [SELLER_NOTIFICATION.MODIFY_DELIVERY]: (id: number) => `/admin/seller/shipping/${id}`,
    [SELLER_NOTIFICATION.MODIFY_RETURN_ORDER]: (id: number) => `/admin/seller/shipping/return-request/${id}`,
    [SELLER_NOTIFICATION.MODIFY_DISPOSAL_ORDER]: (id: number) => `/admin/seller/shipping/return-disposal/${id}`,
    [SELLER_NOTIFICATION.MODIFY_RETURN_IMPORT]: (id: number) => `/admin/seller/return/${id}`,
    [SELLER_NOTIFICATION.MODIFY_RETURN_STOCK]: (id: number) => `/admin/seller/return/${id}`,
    [SELLER_NOTIFICATION.MODIFY_DISPOSAL_IMPORT]: (id: number) => `/admin/seller/return-disposal/${id}`,
    [SELLER_NOTIFICATION.MODIFY_DISPOSAL_STOCK]: (id: number) => `/admin/seller/return-disposal/${id}`,
    [SELLER_NOTIFICATION.DELETE_RETURN_ORDER]: (id: number) => `/admin/seller/shipping/return-request/${id}`,
    [SELLER_NOTIFICATION.DELETE_DISPOSAL_ORDER]: (id: number) => `/admin/seller/shipping/return-disposal/${id}`,
    [SELLER_NOTIFICATION.APPROVE_MODIFY_DELIVERY]: (id: number) => `/admin/seller/shipping/${id}`,
    [SELLER_NOTIFICATION.APPROVE_MODIFY_RETURN_IMPORT]: (id: number) => `/admin/seller/return/${id}`,
    [SELLER_NOTIFICATION.REJECT_DELETE_DELIVERY]: (id: number) => `/admin/seller/shipping/${id}`,
    [SELLER_NOTIFICATION.REJECT_MODIFY_RETURN_IMPORT]: (id: number) => `/admin/seller/return/${id}`,
    [SELLER_NOTIFICATION.APPROVE_MODIFY_RETURN_ORDER]: (id: number) => `/admin/seller/shipping/return-request/${id}`,
    [SELLER_NOTIFICATION.APPROVE_MODIFY_INQUIRY]: (id: number) => `/admin/seller/quote/${id}`,
    [SELLER_NOTIFICATION.APPROVE_DELETE_INQUIRY]: (id: number) => `/admin/seller/quote/${id}`,
    [SELLER_NOTIFICATION.APPROVE_DELETE_RETURN_ORDER]: (id: number) => `/admin/seller/shipping/return-request/${id}`,
    [SELLER_NOTIFICATION.REJECT_DELETE_INQUIRY]: (id: number) => `/admin/seller/quote/${id}`,
    [SELLER_NOTIFICATION.REJECT_MODIFY_RETURN_ORDER]: (id: number) => `/admin/seller/shipping/return-request/${id}`,
    [SELLER_NOTIFICATION.REJECT_DELETE_RETURN_ORDER]: (id: number) => `/admin/seller/shipping/return-request/${id}`,
    [SELLER_NOTIFICATION.APPROVE_MODIFY_INBOUND]: (id: number) => `/admin/seller/import/${id}`,
    [SELLER_NOTIFICATION.APPROVE_DELETE_INBOUND]: (id: number) => `/admin/seller/import/${id}`,
    [SELLER_NOTIFICATION.REJECT_MODIFY_INBOUND]: (id: number) => `/admin/seller/import/${id}`,
    [SELLER_NOTIFICATION.REJECT_DELETE_INBOUND]: (id: number) => `/admin/seller/import/${id}`,
    [SELLER_NOTIFICATION.APPROVE_DELETE_DELIVERY]: (id: number) => `/admin/seller/shipping/${id}`,
    [SELLER_NOTIFICATION.REJECT_MODIFY_INQUIRY]: (id: number) => `/admin/seller/quote/${id}`,
    [SELLER_NOTIFICATION.REJECT_MODIFY_DELIVERY]: (id: number) => `/admin/seller/shipping/${id}`,
    [SELLER_NOTIFICATION.DELETE_RETURN_IMPORT]: (id: number) => `/admin/seller/return-disposal/${id}`,
    [SELLER_NOTIFICATION.DELETE_DISPOSAL_IMPORT]: (id: number) => `/admin/seller/return-disposal/${id}`,
    [SELLER_NOTIFICATION.DELETE_RETURN_STOCK]: (id: number) => `/admin/seller/return-disposal/${id}`,
    [SELLER_NOTIFICATION.DELETE_DISPOSAL_STOCK]: (id: number) => `/admin/seller/return-disposal/${id}`,
    [SELLER_NOTIFICATION.APPROVE_MODIFY_RETURN_STOCK]: (id: number) => `/admin/seller/return-disposal/${id}`,
    [SELLER_NOTIFICATION.APPROVE_MODIFY_DISPOSAL_ORDER]: (id: number) => `/admin/seller/shipping/return-disposal/${id}`,
    [SELLER_NOTIFICATION.APPROVE_MODIFY_DISPOSAL_IMPORT]: (id: number) => `/admin/seller/return-disposal/${id}`,
    [SELLER_NOTIFICATION.APPROVE_MODIFY_DISPOSAL_STOCK]: (id: number) => `/admin/seller/return-disposal/${id}`,
    [SELLER_NOTIFICATION.APPROVE_DELETE_RETURN_IMPORT]: (id: number) => `/admin/seller/return-disposal/${id}`,
    [SELLER_NOTIFICATION.APPROVE_DELETE_RETURN_STOCK]: (id: number) => `/admin/seller/return-disposal/${id}`,
    [SELLER_NOTIFICATION.APPROVE_DELETE_DISPOSAL_ORDER]: (id: number) => `/admin/seller/shipping/return-disposal/${id}`,
    [SELLER_NOTIFICATION.APPROVE_DELETE_DISPOSAL_IMPORT]: (id: number) => `/admin/seller/return-disposal/${id}`,
    [SELLER_NOTIFICATION.APPROVE_DELETE_DISPOSAL_STOCK]: (id: number) => `/admin/seller/return-disposal/${id}`,
    [SELLER_NOTIFICATION.REJECT_MODIFY_RETURN_STOCK]: (id: number) => `/admin/seller/return-disposal/${id}`,
    [SELLER_NOTIFICATION.REJECT_MODIFY_DISPOSAL_ORDER]: (id: number) => `/admin/seller/shipping/return-disposal/${id}`,
    [SELLER_NOTIFICATION.REJECT_MODIFY_DISPOSAL_IMPORT]: (id: number) => `/admin/seller/return-disposal/${id}`,
    [SELLER_NOTIFICATION.REJECT_MODIFY_DISPOSAL_STOCK]: (id: number) => `/admin/seller/return-disposal/${id}`,
    [SELLER_NOTIFICATION.REJECT_DELETE_RETURN_IMPORT]: (id: number) => `/admin/seller/return-disposal/${id}`,
    [SELLER_NOTIFICATION.REJECT_DELETE_RETURN_STOCK]: (id: number) => `/admin/seller/return-disposal/${id}`,
    [SELLER_NOTIFICATION.REJECT_DELETE_DISPOSAL_ORDER]: (id: number) => `/admin/seller/shipping/return-disposal/${id}`,
    [SELLER_NOTIFICATION.REJECT_DELETE_DISPOSAL_IMPORT]: (id: number) => `/admin/seller/return-disposal/${id}`,
    [SELLER_NOTIFICATION.REJECT_DELETE_DISPOSAL_STOCK]: (id: number) => `/admin/seller/return-disposal/${id}`,
    [SELLER_NOTIFICATION.INVENTORY_CONVERSION_APPROVE]: (id: number) => `/admin/seller/shipping/return-disposal/${id}`,
  },
  warehouse: {
    [WAREHOUSE_NOTIFICATION.INQUIRY_REQUEST_ARRIVES]: (id: number) => `/admin/inquiry/${id}`, // Inquiry request arrives
    [WAREHOUSE_NOTIFICATION.APPROVE_INQUIRY]: (id: number) => `/admin/inquiry/${id}`, // Approve Inquiry
    [WAREHOUSE_NOTIFICATION.REJECT_INQUIRY]: (id: number) => `/admin/inquiry/${id}`, // Reject Inquiry
    [WAREHOUSE_NOTIFICATION.IMPORT_REQUESTED]: (id: number) => `/admin/inbound/${id}`, //  Import requested
    [WAREHOUSE_NOTIFICATION.DELIVERY_REQUESTED]: (id: number) => `/admin/delivery/${id}`, // Delivery requested
    [WAREHOUSE_NOTIFICATION.RETURN_IMPORT_REQUESTED]: (id: number) => `/admin/return/${id}?return_type=Import`, // Return requested
    [WAREHOUSE_NOTIFICATION.RETURN_STOCK_REQUESTED]: (id: number) => `/admin/return/${id}?return_type=Stock`, // Return requested
    [WAREHOUSE_NOTIFICATION.EXCHANGE_REQUESTED]: (id: number) => `/admin/returnDelivery/${id}?return_type=Order`, // Exchange requested
    [WAREHOUSE_NOTIFICATION.DISPOSAL_IMPORT_REQUESTED]: (id: number) => `/admin/return/${id}?return_type=Import`, // Disposal requested
    [WAREHOUSE_NOTIFICATION.DISPOSAL_STOCK_REQUESTED]: (id: number) => `/admin/return/${id}?return_type=Stock`, // Disposal requested
    [WAREHOUSE_NOTIFICATION.SETTLEMENT_APPROVED]: (id: number) => `/admin/billingInquiry/billingInquiryDetail/${id}`, // Settlement approved
    [WAREHOUSE_NOTIFICATION.BUSK_SETTLEMENT_REQUESTED]: (id: number) => `/admin/serviceInquiry/serviceInquiryDetail/${id}`, // Busk settlement requested
    //for comment
    [WAREHOUSE_NOTIFICATION.MODIFY_DELIVERY]: (id: number) => `/admin/delivery/${id}`,
    [WAREHOUSE_NOTIFICATION.MODIFY_INBOUND]: (id: number) => `/admin/inbound/${id}`,
    [WAREHOUSE_NOTIFICATION.MODIFY_RETURN_IMPORT]: (id: number) => `/admin/return/${id}?return_type=Import`,
    [WAREHOUSE_NOTIFICATION.MODIFY_DISPOSAL_IMPORT]: (id: number) => `/admin/return/${id}?return_type=Import`,
    [WAREHOUSE_NOTIFICATION.DELETE_RETURN_IMPORT]: (id: number) => `/admin/return/${id}?return_type=Import`,
    [WAREHOUSE_NOTIFICATION.DELETE_DISPOSAL_IMPORT]: (id: number) => `/admin/return/${id}?return_type=Import`,
    [WAREHOUSE_NOTIFICATION.DELETE_DELIVERY]: (id: number) => `/admin/delivery/${id}`,
    [WAREHOUSE_NOTIFICATION.DELETE_INBOUND]: (id: number) => `/admin/inbound/${id}`,
    [WAREHOUSE_NOTIFICATION.APPROVE_MODIFY_DELIVERY]: (id: number) => `/admin/delivery/${id}`,
    [WAREHOUSE_NOTIFICATION.APPROVE_MODIFY_RETURN_ORDER]: (id: number) => `/admin/returnDelivery/${id}?return_type=Order`,
    [WAREHOUSE_NOTIFICATION.APPROVE_MODIFY_RETURN_IMPORT]: (id: number) => `/admin/return/${id}?return_type=Import`,
    [WAREHOUSE_NOTIFICATION.APPROVE_DELETE_RETURN_ORDER]: (id: number) => `/admin/returnDelivery/${id}?return_type=Order`,
    [WAREHOUSE_NOTIFICATION.REJECT_DELETE_DELIVERY]: (id: number) => `/admin/delivery/${id}`,
    [WAREHOUSE_NOTIFICATION.REJECT_MODIFY_RETURN_ORDER]: (id: number) => `/admin/returnDelivery/${id}?return_type=Order`,
    [WAREHOUSE_NOTIFICATION.REJECT_MODIFY_RETURN_IMPORT]: (id: number) => `/admin/return/${id}?return_type=Import`,
    [WAREHOUSE_NOTIFICATION.REJECT_DELETE_RETURN_ORDER]: (id: number) => `/admin/returnDelivery/${id}?return_type=Order`,
    [WAREHOUSE_NOTIFICATION.MODIFY_INQUIRY]: (id: number) => `/admin/inquiry/${id}`,
    [WAREHOUSE_NOTIFICATION.APPROVE_MODIFY_INBOUND]: (id: number) => `/admin/inbound/${id}`,
    [WAREHOUSE_NOTIFICATION.APPROVE_MODIFY_DISPOSAL_IMPORT]: (id: number) => `/admin/return/${id}?return_type=Import`,
    [WAREHOUSE_NOTIFICATION.APPROVE_MODIFY_RETURN_STOCK]: (id: number) => `/admin/return/${id}?return_type=Stock`,
    [WAREHOUSE_NOTIFICATION.APPROVE_MODIFY_DISPOSAL_STOCK]: (id: number) => `/admin/return/${id}?return_type=Stock`,
    [WAREHOUSE_NOTIFICATION.APPROVE_MODIFY_DISPOSAL_ORDER]: (id: number) => `/admin/returnDelivery/${id}?return_type=Order`,
    [WAREHOUSE_NOTIFICATION.APPROVE_DELETE_INBOUND]: (id: number) => `/admin/inbound/${id}`,
    [WAREHOUSE_NOTIFICATION.APPROVE_DELETE_DELIVERY]: (id: number) => `/admin/delivery/${id}`,
    [WAREHOUSE_NOTIFICATION.APPROVE_DELETE_RETURN_IMPORT]: (id: number) => `/admin/return/${id}?return_type=Import`,
    [WAREHOUSE_NOTIFICATION.APPROVE_DELETE_DISPOSAL_IMPORT]: (id: number) => `/admin/return/${id}?return_type=Import`,
    [WAREHOUSE_NOTIFICATION.APPROVE_DELETE_RETURN_STOCK]: (id: number) => `/admin/return/${id}?return_type=Stock`,
    [WAREHOUSE_NOTIFICATION.APPROVE_DELETE_DISPOSAL_STOCK]: (id: number) => `/admin/return/${id}?return_type=Stock`,
    [WAREHOUSE_NOTIFICATION.APPROVE_DELETE_DISPOSAL_ORDER]: (id: number) => `/admin/returnDelivery/${id}?return_type=Order`,
    [WAREHOUSE_NOTIFICATION.REJECT_MODIFY_INBOUND]: (id: number) => `/admin/inbound/${id}`,
    [WAREHOUSE_NOTIFICATION.REJECT_MODIFY_DELIVERY]: (id: number) => `/admin/delivery/${id}`,
    [WAREHOUSE_NOTIFICATION.REJECT_DELETE_INBOUND]: (id: number) => `/admin/inbound/${id}`,
    [WAREHOUSE_NOTIFICATION.REJECT_MODIFY_RETURN_STOCK]: (id: number) => `/admin/return/${id}?return_type=Stock`,
    [WAREHOUSE_NOTIFICATION.REJECT_MODIFY_DISPOSAL_IMPORT]: (id: number) => `/admin/return/${id}?return_type=Import`,
    [WAREHOUSE_NOTIFICATION.REJECT_MODIFY_DISPOSAL_STOCK]: (id: number) => `/admin/return/${id}?return_type=Stock`,
    [WAREHOUSE_NOTIFICATION.REJECT_MODIFY_DISPOSAL_ORDER]: (id: number) => `/admin/returnDelivery/${id}?return_type=Order`,
    [WAREHOUSE_NOTIFICATION.REJECT_DELETE_RETURN_IMPORT]: (id: number) => `/admin/return/${id}?return_type=Import`,
    [WAREHOUSE_NOTIFICATION.REJECT_DELETE_RETURN_STOCK]: (id: number) => `/admin/return/${id}?return_type=Stock`,
    [WAREHOUSE_NOTIFICATION.REJECT_DELETE_DISPOSAL_IMPORT]: (id: number) => `/admin/return/${id}?return_type=Import`,
    [WAREHOUSE_NOTIFICATION.REJECT_DELETE_DISPOSAL_STOCK]: (id: number) => `/admin/return/${id}?return_type=Stock`,
    [WAREHOUSE_NOTIFICATION.REJECT_DELETE_DISPOSAL_ORDER]: (id: number) => `/admin/returnDelivery/${id}?return_type=Order`,
    [WAREHOUSE_NOTIFICATION.DELETE_RETURN_STOCK]: (id: number) => `/admin/return/${id}?return_type=Stock`,
    [WAREHOUSE_NOTIFICATION.DELETE_DISPOSAL_STOCK]: (id: number) => `/admin/return/${id}?return_type=Stock`,
    [WAREHOUSE_NOTIFICATION.DELETE_RETURN_ORDER]: (id: number) => `/admin/returnDelivery/${id}?return_type=Order`,
    [WAREHOUSE_NOTIFICATION.DELETE_DISPOSAL_ORDER]: (id: number) => `/admin/returnDelivery/${id}?return_type=Order`,
    [WAREHOUSE_NOTIFICATION.MODIFY_RETURN_STOCK]: (id: number) => `/admin/return/${id}?return_type=Stock`,
    [WAREHOUSE_NOTIFICATION.MODIFY_DISPOSAL_STOCK]: (id: number) => `/admin/return/${id}?return_type=Stock`,
    [WAREHOUSE_NOTIFICATION.MODIFY_RETURN_ORDER]: (id: number) => `/admin/returnDelivery/${id}?return_type=Order`,
    [WAREHOUSE_NOTIFICATION.MODIFY_DISPOSAL_ORDER]: (id: number) => `/admin/returnDelivery/${id}?return_type=Order`,
    [WAREHOUSE_NOTIFICATION.APPROVE_MODIFY_INQUIRY]: (id: number) => `/admin/inquiry/${id}`,
    [WAREHOUSE_NOTIFICATION.APPROVE_DELETE_INQUIRY]: (id: number) => `/admin/inquiry/${id}r`,
    [WAREHOUSE_NOTIFICATION.REJECT_MODIFY_INQUIRY]: (id: number) => `/admin/inquiry/${id}`,
    [WAREHOUSE_NOTIFICATION.REJECT_DELETE_INQUIRY]: (id: number) => `/admin/inquiry/${id}`,
  }
};